import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "./DataTable";
import RewardsContext from "./context";
import { useRewardsManager } from "./useRewards";

const Rewards = () => {
  const navigate = useNavigate();
  return (
    <Paper sx={{ p: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5">Prêmios</Typography>

        <Button onClick={() => navigate("./create")} variant="contained">
          Registrar
        </Button>
      </Box>
      <DataTable />
    </Paper>
  );
};

const Index = () => {
  return (
    <RewardsContext.Provider value={useRewardsManager()}>
      <Rewards />
    </RewardsContext.Provider>
  );
};

export default React.memo(Index);
